export default "__VITE_ASSET__BStLcq71__"